module.exports = __webpack_public_path__ + "img/pyros.a2644baa.jpg";